const Reels =()=>{
 return(
    <div>
        <h2>Reels</h2>
    </div>
 )
}
export default Reels;